import React, { useCallback, useState } from 'react'
import { Box, Button } from '@mui/material'
import { GDriveFolderIdInput } from './components/GDriveFolderIdInput'
import { useGetSheetTab } from './drive'
import { parseCsvDataAsList } from '../../Helpers'

export function GoogleSheetImport({
  onRetrieveData,
}: {
  onRetrieveData: (data: string[][]) => void
}) {
  const [sheetId, setSheetId] = useState('')
  const getSheet = useGoogleSheetAdd(onRetrieveData)

  const onGet = async () => {
    return getSheet(sheetId)
  }
  return (
    <Box>
      <Box>Google Sheet ID</Box>
      <Box>
        <GDriveFolderIdInput
          currentId={sheetId}
          onIdChange={(id) => setSheetId(id)}
        />
        <Button disabled={!sheetId} onClick={onGet}>
          Get
        </Button>
      </Box>
    </Box>
  )
}

function useGoogleSheetAdd(onRetrieveData: (data: string[][]) => void) {
  const getSheet = useGetSheetTab()

  return useCallback(
    async (fileId: string) => {
      const data = await getSheet(fileId)
      if (!data) {
        onRetrieveData([])
      } else {
        const result = await parseCsvDataAsList(data)
        onRetrieveData(result)
      }
    },
    [getSheet, onRetrieveData],
  )
}
